"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PAGINATION = exports.DEFAULT_PAGE_SIZE = exports.DEFAULT_ORDER_COLUMNS = void 0;
var DEFAULT_ORDER_COLUMNS = [{
  'code': 'zone',
  'width': 100
}, {
  'code': 'projectCode',
  'width': 140
}, {
  'code': 'customerCode',
  'width': 140
}, {
  'code': 'shipmentReference',
  'width': 140
}, {
  'code': 'commodityType',
  'width': 140
}, {
  'code': 'serviceType',
  'width': 200
}, {
  'code': 'serviceName',
  'width': 140
}, {
  'code': 'serviceProviderName',
  'width': 140
}, {
  'code': 'weight',
  'width': 120
}, {
  'code': 'volume',
  'width': 100
}, {
  'code': 'cartons',
  'width': 100
}, {
  'code': 'pallets',
  'width': 100
}, {
  'code': 'quantity',
  'width': 100
}, {
  'code': 'pickDateTime',
  'width': 160
}, {
  'code': 'pickDistrict',
  'width': 160
}, {
  'code': 'pickBuilding',
  'width': 260
}, {
  'code': 'pickCompName',
  'width': 260
}, {
  'code': 'pickPhoneNumber',
  'width': 160
}, // { 'code': 'pickLatLng', 'width': 270 },
{
  'code': 'dropDateTime',
  'width': 160
}, {
  'code': 'dropDistrict',
  'width': 160
}, {
  'code': 'dropBuilding',
  'width': 260
}, {
  'code': 'dropCompName',
  'width': 260
}, {
  'code': 'dropPhoneNumber',
  'width': 160
}, // { 'code': 'dropLatLng', 'width': 270 },
{
  'code': 'remarks',
  'width': 300
}, {
  'code': 'itemInfo',
  'width': 600
}, {
  'code': 'assemblyMinutes',
  'width': 140
}, {
  'code': 'wallMountQuantity',
  'width': 140
}, {
  'code': 'disposalQuantity',
  'width': 140
}, {
  'code': 'staircaseQuantity',
  'width': 140
}];
exports.DEFAULT_ORDER_COLUMNS = DEFAULT_ORDER_COLUMNS;
var DEFAULT_PAGE_SIZE = 100;
exports.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
var DEFAULT_PAGINATION = {
  'currentPage': 1,
  'order': 'DESC',
  'orderBy': null,
  'orderType': null,
  'pageSize': DEFAULT_PAGE_SIZE,
  'totalData': 0
};
exports.DEFAULT_PAGINATION = DEFAULT_PAGINATION;